import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import Full from '@/components/Full'
import DbManage from '@/db/DbManage'
import SiteSet from '@/components/website/SiteSet'
import ZCFB from '@/components/zhongchou/ZCFB'
import UpLoadKSOss from '@/views/uploadfile/UpLoadKSOss'
import PayTest from '@/wx/PayTest'
import WxJsTest from '@/wx/WxJsTest'
import FMain from '@/components/frontlayout/FMain'
import CusInfo from '@/components/cus/CusInfo'
import CusUsersGroup from '@/components/cus/CusUsersGroup'
import CusUsers from '@/components/cus/CusUsers'
import GoodsBrand from '@/components/goods/GoodsBrand'
import GoodsSpec from '@/components/goods/GoodsSpec'
import GoodsType from '@/components/goods/GoodsType'
import GoodsAttr from '@/components/goods/GoodsAttr'
import GoodsImg from '@/components/goods/GoodsImg'
import GoodsAttrSpec from '@/components/newgoods/GoodsAttrSpec'
import PermissionControll from '@/components/control/PermissionControll'
import ChannelControl from '@/components/control/ChannelControl'
import GoodsControl from '@/components/control/GoodsControl'
import LayoutControl from '@/components/control/LayoutControl'
import SaleControl from '@/components/control/SaleControl'
import AllArea from '@/components/data/AllArea'
import PageInfo from '@/components/website/PageInfo'
import PageGroup from '@/components/website/PageGroup'
import PageContext from '@/components/website/PageContext'
import SymPosiumList from '@/components/website/SymPosiumList'
import SymPosiumPage from '@/components/website/SymPosiumPage'
import BucketMana from '@/components/oss/BucketMana'
import WxSendMsg from '@/components/wx/WxSendMsg'
import OssPath from '@/components/oss/OssPath'
import OssResource from '@/components/oss/OssResource'
import OrderInfo from '@/components/order/OrderInfo'
import OrderInstead from '@/components/order/OrderInstead'
import FXOrder from '@/components/order/FXOrder'
import OrderType from '@/components/order/OrderType'
import CardOrderInfo from '@/components/order/CardOrderInfo'
import OrderInput from '@/components/order/OrderInput'
import MemberCard from '@/components/member/MemberCard'
import MemberInfo from '@/components/member/MemberInfo'
import MemberLabel from '@/components/member/MemberLabel'
import BigFileUpload from '@/components/protest/BigFileUpload'
import AccountInfo from '@/components/account/AccountInfo'
import UserPermission from '@/components/account/UserPermission'
import PSManage from '@/components/cpmana/PSManage'
import WSManage from '@/components/cpmana/WSManage'
import ChannelFZ from '@/components/finance/ChannelFZ'
import FxFZ from '@/components/finance/FxFZ'
import TKZD from '@/components/finance/TKZD'
import YCZD from '@/components/finance/YCZD'
import ZDInput from '@/components/finance/ZDInput'
import QueryCTQD from '@/components/query/QueryCTQD'
import QueryFXQD from '@/components/query/QueryFXQD'
import IndustriesMana from '@/components/cus/IndustriesMana'
import CustomerGroupMana from '@/components/cus/CustomerGroupMana'
import FxControl from '@/components/control/FxControl'
import SaleFB from '@/components/control/SaleFB'
import KqMana from '@/components/cardticket/KqMana'
import TCard from '@/components/cardticket/TCard'
import WxMenuSet from '@/components/wx/WxMenuSet'
import WxOpenID from '@/components/wx/WxOpenID'
import MemberMana from '@/components/member/MemberMana'
import TeacherMana from '@/components/teacher/TeacherMana'
import CourseMana from '@/components/course/CourseMana'
import ClassMana from '@/components/class/ClassMana'
import CoursePlan from '@/components/course/CoursePlan'
import TeachSchedule from '@/components/course/TeachSchedule'
import MemberArrange from '@/components/course/MemberArrange'
import VacationMana from '@/components/course/VacationMana'
import MemberMsg from '@/components/message/MemberMsg'
import RecMana from '@/components/course/RecMana'
import WxShare from '@/components/wx/WxShare'
import WxUser from '@/components/wx/WxUser'
import WxAccount from '@/components/wx/WxAccount'
import ExtensionArea from '@/components/extension/ExtensionArea'
import ExtensionMan from '@/components/extension/ExtensionMan'
import ENewGoods from '@/components/newgoods/NewGoods'
import EGStore from '@/components/newgoods/GStore'
import GTypeList from '@/components/newgoods/GTypeList'
import GBrand from '@/components/newgoods/GBrand'
import RegeditCus from '@/components/regedit/RegCus'
import ReSetPW from '@/components/regedit/ReSetPW'
import UserBaseInfo from '@/components/regedit/UserBaseInfo'
import CompleteInfo from '@/components/regedit/CompleteInfo'
import AddModel from '@/components/model/AddModel'
import SMSSet from '@/components/system/SMSSet'
import PaySet from '@/components/system/PaySet'
import BrandSet from '@/components/control/BrandSet.vue'
import KJRK from '@/components/control/KJRK.vue'
import GoodsTJ from '@/components/control/GoodsTJ.vue'
import ZTSet from '@/components/control/ZTSet.vue'
import ExcelMods from '@/components/workspace/ExcelMods.vue'
import JsonChange from '@/components/jsoncl/JsonChange.vue'
import GetHD from '@/components/gg/GetHD.vue'
import GetGGClick from '@/components/gg/GetGGClick.vue'
import TJHD from '@/components/gg/TJHD.vue'
import QueryGG from '@/components/gg/QueryGG.vue'
import QueryCInfo from '@/components/gg/QueryCInfo.vue'
import QueryCAd from '@/components/gg/QueryCAd.vue'
import GetCAndC from '@/components/gg/GetCAndC.vue'
import NewTest from '@/components/gg/NewTest.vue'
import WxKF from '@/components/wx/WxKF.vue'
import KFMana from '@/components/kf/KFMana.vue'
import KafkaEx from '@/components/kafkaex/KafkaEx.vue'
import ChatGPT from '@/components/chatgpt/ChatGPT.vue'
import WsInfo from '@/components/ws/WsInfo.vue'
import PsInfo from '@/components/ps/PsInfo.vue'
import Midjourney from '@/components/ai/Midjourney.vue'
import FTPro from '@/components/pro/ft/FTPro.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/RegeditCus',
      name: 'RegeditCus',
      component: RegeditCus
    },
    {
      path: '/ReSetPW',
      name: 'ReSetPW',
      component: ReSetPW
    },
    {
      path: '/Home',
      name: 'Home',
      component: Full,
      children: [
        {
          path: '/Dashboard',
          name: '首页',
          component: Dashboard
        },
        {
          path: '/FTPro',
          name: '丰田项目',
          component: FTPro
        },
        {
          path: '/KafkaEx',
          name: '信息管理',
          component: KafkaEx
        },
        {
          path: '/JsonChange',
          name: 'JsonChange',
          component: JsonChange
        },
        {
          path: '/Midjourney',
          name: 'Midjourney',
          component: Midjourney
        },
        {
          path: '/ChatGPT',
          name: 'ChatGPT',
          component: ChatGPT
        },
        {
          path: '/KFMana',
          name: '客服',
          component: KFMana
        },
        {
          path: '/WsInfo',
          name: '仓储管理',
          component: WsInfo
        },
        {
          path: '/PsInfo',
          name: '配送管理',
          component: PsInfo
        },
        {
          path: '/WxKF',
          name: '客服',
          component: WxKF
        },{
          path: '/GetCAndC',
          name: '广告&回调',
          component: GetCAndC
        },{
          path: '/QueryGG',
          name: '广告管理',
          component: QueryGG
        },{
          path: '/GBrand',
          name: '广告',
          component: GBrand
        },{
          path: '/QueryCAd',
          name: '渠道广告',
          component: QueryCAd
        },{
          path: '/NewTest',
          name: '测试异步回调',
          component: NewTest
        },{
          path: '/QueryCInfo',
          name: '渠道管理',
          component: QueryCInfo
        },{
          path: '/GetHD',
          name: '实时回调',
          component: GetHD
        },{
          path: '/GetGGClick',
          name: '实时点击',
          component: GetGGClick
        },{
          path: '/TJHD',
          name: '回调统计',
          component: TJHD
        },
        {
          path: '/CardOrderInfo',
          name: '次卡订单',
          component: CardOrderInfo
        },
        {
          path: '/ZTSet',
          name: '专题配置',
          component: ZTSet
        },
        {
          path: '/GTypeList',
          name: '类别列表',
          component: GTypeList
        },
        {
          path: '/BrandSet',
          name: '轮播图配置',
          component: BrandSet
        },
        {
          path: '/KJRK',
          name: '快捷入口',
          component: KJRK
        },
        {
          path: '/TCard',
          name: '次卡管理',
          component: TCard
        },
        {
          path: '/SaleFB',
          name: '促销发布',
          component: SaleFB
        },
        {
          path: '/ExcelMods',
          name: 'Excel模板',
          component: ExcelMods
        },
        {
          path: '/GoodsTJ',
          name: '推荐产品',
          component: GoodsTJ
        },
        {
          path: '/GoodsAttrSpec',
          name: '规格属性',
          component: GoodsAttrSpec
        },
        {
          path: '/SMSSet',
          name: '短信配置',
          component: SMSSet
        },
        {
          path: '/PaySet',
          name: '支付配置',
          component: PaySet
        },
        {
          path: '/AddModel',
          name: '模块添加',
          component: AddModel
        },
        {
          path: '/NewGoods',
          name: '新产品',
          component: ENewGoods
        },
        {
          path: '/GoodsMana',
          name: '产品库',
          component: EGStore
        },
        {
          path: '/UserBaseInfo',
          name: '账号信息',
          component: UserBaseInfo
        },
        {
          path: '/CompleteInfo',
          name: '账号升级',
          component: CompleteInfo
        },
        {
          path: '/ExtensionArea',
          name: '推广区域',
          component: ExtensionArea
        },
        {
          path: '/ExtensionMan',
          name: '推广人员',
          component: ExtensionMan
        },
        {
          path: '/WxShare',
          name: '微信分享',
          component: WxShare
        },
        {
          path: '/WxUser',
          name: '微信用户',
          component: WxUser
        },
        {
          path: '/WxAccount',
          name: '微信账号',
          component: WxAccount
        },
        {
          path: '/RecMana',
          name: '上课记录核销',
          component: RecMana
        },
        {
          path: '/MemberMsg',
          name: '会员消息',
          component: MemberMsg
        },
        {
          path: '/MemberArrange',
          name: '会员排班',
          component: MemberArrange
        },
        {
          path: '/VacationMana',
          name: '请假管理',
          component: VacationMana
        },
        {
          path: '/TeacherMana',
          name: '讲师管理',
          component: TeacherMana
        },
        {
          path: '/ClassMana',
          name: '班级管理',
          component: ClassMana
        },
        {
          path: '/CoursePlan',
          name: '课程预约',
          component: CoursePlan
        },
        {
          path: '/TeachSchedule',
          name: '定期排课',
          component: TeachSchedule
        },
        {
          path: '/CourseMana',
          name: '课程管理',
          component: CourseMana
        },
        {
          path: '/IndustriesMana',
          name: '行业管理',
          component: IndustriesMana
        },
        {
          path: '/CustomerGroupMana',
          name: '群组管理',
          component: CustomerGroupMana
        },
        {
          path: '/WxMenuSet',
          name: '菜单管理',
          component: WxMenuSet
        },
        {
          path: '/WxOpenID',
          name: '微信用户信息',
          component: WxOpenID
        },
        {
          path: '/WxSendMsg',
          name: '发送消息',
          component: WxSendMsg
        },
        {
          path: '/KqMana',
          name: '卡券管理',
          component: KqMana
        },
        {
          path: '/PSManage',
          name: '配送管理',
          component: PSManage
        },
        {
          path: '/FxControl',
          name: '分销管控',
          component: FxControl
        },
        {
          path: '/WSManage',
          name: '仓储管理',
          component: WSManage
        },
        {
          path: '/ChannelFZ',
          name: '渠道分账',
          component: ChannelFZ
        },
        {
          path: '/TKZD',
          name: '退款账单',
          component: TKZD
        },
        {
          path: '/FxFZ',
          name: '分销分账',
          component: FxFZ
        },
        {
          path: '/YCZD',
          name: '异常订单',
          component: YCZD
        },
        {
          path: '/ZDInput',
          name: '订单入账',
          component: ZDInput
        },
        {
          path: '/QueryCTQD',
          name: '渠道订单查询',
          component: QueryCTQD
        },
        {
          path: '/QueryFXQD',
          name: '分销订单查询',
          component: QueryFXQD
        },
        {
          path: '/SiteSet',
          name: '网站设置',
          component: SiteSet
        },
        {
          path: '/ZCFB',
          name: '众筹发布',
          component: ZCFB
        },
        {
          path: '/CusInfo',
          name: '客户信息',
          component: CusInfo
        },
        {
          path: '/CusUsersGroup',
          name: '客户用户组',
          component: CusUsersGroup
        },
        {
          path: '/CusUsers',
          name: '客户用户',
          component: CusUsers
        },
        {
          path: '/GoodsBrand',
          name: '产品品牌',
          component: GoodsBrand
        },
        {
          path: '/GoodsSpec',
          name: '产品规格',
          component: GoodsSpec
        },
        {
          path: '/GoodsType',
          name: '产品类别',
          component: GoodsType
        },
        {
          path: '/GoodsAttr',
          name: '产品属性',
          component: GoodsAttr
        },
        {
          path: '/GoodsImg',
          name: '产品图片',
          component: GoodsImg
        },
        {
          path: '/PermissionControll',
          name: '权限管控',
          component: PermissionControll
        },
        {
          path: '/ChannelControl',
          name: '渠道管控',
          component: ChannelControl
        },
        {
          path: '/AccountInfo',
          name: '账号信息',
          component: AccountInfo
        },
        {
          path: '/UserPermission',
          name: '用户权限',
          component: UserPermission
        },
        {
          path: '/GoodsControl',
          name: '货源管控',
          component: GoodsControl
        },
        {
          path: '/LayoutControl',
          name: '布局管控',
          component: LayoutControl
        },
        {
          path: '/SaleControl',
          name: '促销管控',
          component: SaleControl
        },
        {
          path: '/AllArea',
          name: '全国区域管理',
          component: AllArea
        },
        {
          path: '/PageInfo',
          name: '页面信息管理',
          component: PageInfo
        },
        {
          path: '/PageGroup',
          name: '页面组管理',
          component: PageGroup
        },
        {
          path: '/PageContext',
          name: '页面内容填充',
          component: PageContext
        },
        {
          path: '/BucketMana',
          name: 'OssBucket管理',
          component: BucketMana
        },
        {
          path: '/OssPath',
          name: 'Oss路径管理',
          component: OssPath
        },
        {
          path: '/OssResource',
          name: 'Oss资源管理',
          component: OssResource
        },
        {
          path: '/SymPosiumList',
          name: '专题列表',
          component: SymPosiumList
        },
        {
          path: '/SymPosiumPage',
          name: '专题页面',
          component: SymPosiumPage
        },
        {
          path: '/OrderInfo',
          name: '订单信息',
          component: OrderInfo
        },
        {
          path: '/OrderInput',
          name: '订单补录',
          component: OrderInput
        },
        {
          path: '/OrderInstead',
          name: '代客下单',
          component: OrderInstead
        },
        {
          path: '/FXOrder',
          name: '分销订单',
          component: FXOrder
        },
        {
          path: '/OrderType',
          name: '订单类别',
          component: OrderType
        },
        {
          path: '/MemberCard',
          name: '会员卡',
          component: MemberCard
        },
        {
          path: '/MemberInfo',
          name: '会员信息',
          component: MemberInfo
        },
        {
          path: '/MemberLabel',
          name: '会员标签',
          component: MemberLabel
        },
        {
          path: '/MemberMana',
          name: '会员管理',
          component: MemberMana
        }
      ]
    },
    {
      path: '/DbManage',
      name: 'DbManage',
      component: DbManage
    },
    {
      path: '/UpLoadKSOss',
      name: 'UpLoadKSOss',
      component: UpLoadKSOss
    },
    {
      path: '/BigFileUpload',
      name: 'BigFileUpload',
      component: BigFileUpload
    },
    {
      path: '/PayTest',
      name: 'PayTest',
      component: PayTest
    },
    {
      path: '/WxJsTest',
      name: '微信JS测试',
      component: WxJsTest
    },
    {
      path: '/FMain',
      name: '电商平台',
      component: FMain
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js